import request from '@/utils/request'

// epmsb400
export function epmsb400(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb400/epmsb400`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epmsb401
export function epmsb401(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb400/epmsb401`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epmsb402
export function epmsb402(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb400/epmsb402`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// epmsb400Save
export function epmsb400Save(param) {
  let data = param
  return request({
    url: `/requestPoMaterial/epmsb400/epmsb400Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}